import './styles/index.scss';
import { indexBlocks } from './blocks/index-blocks';
import { activePage } from "./scripts/active-page";
import { generalPageAnimation } from './scripts/generalPageAnimation';
import { headerSticky } from "./scripts/header-sticky";
import { inViewAnimations } from "./scripts/InViewAnimations";
import { splitTextAnimations } from "./scripts/SplitTextAnimations";
import { singlePostScript } from "./scripts/singlePostScript";
import { initImageTooltips } from "./scripts/cursorTooltip";
import $ from "jquery";


document.addEventListener('DOMContentLoaded', async () => {
  indexBlocks();
  activePage();
  headerSticky();
  generalPageAnimation();
  singlePostScript()
  inViewAnimations()
  splitTextAnimations()
  initImageTooltips();
});
